<script setup lang="ts">
import { ut_getText } from '@base/utils/utils'
import { useAppIndexStore } from '@base/stores/indexStore'
import { usePathStore } from '@base/stores/pathStore'

// The Wilo World import parameter of the current level2 application node: its path in the names
// expNavigationWW exports (cWilo + al_<uuid> of the three levels), plus the current filter selection
// as it stands. Everything comes from the stores, never from the browser URL.
const indexStore = useAppIndexStore()
const pathStore = usePathStore()
const copiedActive: Ref<boolean> = ref(false)

const wiloWorldParam = computed((): string => {
  const uuids: string[] = (pathStore.getPathData(indexStore.state.paramData) || []).slice(-3).map(node => node.attrs?.uuid || '')
  // A missing uuid would make a path Wilo World cannot resolve — show nothing rather than that.
  if (uuids.length !== 3 || uuids.some(uuid => !uuid)) return ''
  const psx: string = indexStore.state.paramData.queryUrlServer.psx || ''
  return 'path=' + ['cWilo', ...uuids.map(uuid => 'al_' + uuid)].join('/') + (psx ? '&psx=' + psx : '')
})

function copyToClipBoard() {
  navigator.clipboard.writeText(wiloWorldParam.value)
  copiedActive.value = true
  setTimeout(() => { copiedActive.value = false }, 2500)
}
</script>

<template>
  <UContainer v-if="wiloWorldParam" class="mt-2 mb-6">
    <div class="flex items-center gap-4">
      <UButton :disabled="copiedActive" icon="i-wilo-copy-solid-full" class="text-white shrink-0" :label="ut_getText(!copiedActive ? 'txt_copy-to-clipboard' : 'txt_copied')" @click="copyToClipBoard" />
      <span class="break-all">{{ wiloWorldParam }}</span>
    </div>
  </UContainer>
</template>
